import { selectSectionMetadataContext } from "./section-context";

import { t } from "i18n/i18n";
import { RootState } from "store/index";
import { sectionSelectors } from "store/selectors";

export const ORG_VIEW_EXPLANATION_CONTEXT = t("ai.org_view_explanation_long");

export const ORG_SECTION_STRUCTURE_EXPLANATION_CONTEXT = t("ai.org_section_structure_explanation");

export const selectSectionListContext = (state: RootState) => {
  const sections = sectionSelectors.selectAll(state);
  const lines = sections.map((section) => selectSectionMetadataContext(state, section)).join("\n");

  return t("ai.org_sections_available", { courses: lines });
};
